import React, { useContext, useEffect, useState } from "react"

import { Link } from "gatsby"
import { Row, Col } from "react-bootstrap"

import Edit from "../../../images/icons/wdn-edit.png"
import Wrong from "../../../images/icons/wdn-wrong.png"
import Warning from "../../../images/icons/wdn-warning.png"

import { GlobalAuthContext } from "../../../context/authContext"

import {
  CANDIDATE_PROFESSIONAL_FORM_SUBMIT,
  UPDATE_INDUSTRY_SKILLS,
} from "../actions/professionalAction"

import "./professional-form.scss"
import TimeLine from "../timeline"
import Spinner from "../../spinner/spinner"
import TagInput from "../../input/tag-input"
import InputBox from "../../input/wdn-input-box"
import InputTextBox from "../../input/input-text-box"
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css"
import {
  formatSkillsForSelect,
  selectValueFromId,
} from "../../../utils/format-skills-for-select"
import {
  formatSalaryWithComma,
  formatSalaryWithoutComma,
} from "../../../utils/formatSalary"

const ProfessionalForm = props => {
  const {
    setFormState,
    formState,
    images,
    experiences,
    setAddPastExp,
    setAddPortfolio,
    isLoading,
    setShowDeleteForm,
    configData,
    country,
  } = props

  const [isProcessing, setProcessing] = useState(false)
  const [errors, setErrors] = useState("")

  const handleJobTitleChange = value => {
    setFormState({ ...formState, position: value })
  }
  const handleIndustryChange = value => {
    UPDATE_INDUSTRY_SKILLS(value, formState, setFormState)
  }

  const handleStatusChange = value => {
    setFormState({ ...formState, status: value })
  }

  const handleExpectedSalaryChange = value => {
    const v = formatSalaryWithoutComma(value)
    setFormState({ ...formState, salary: v || undefined })
  }

  const handleWorkTypeChange = value => {
    setFormState({ ...formState, job_type_id: value, job_type: value })
  }

  const handleWorkShiftChange = value => {
    setFormState({ ...formState, job_shift_id: value, job_shift: value })
  }

  const handleTimelineEditButtonClick = (value, id) => {
    setAddPastExp(value, id)
  }

  const { dispatch } = useContext(GlobalAuthContext)

  const handleSave = e => {
    e.preventDefault()
    setProcessing(true)
    CANDIDATE_PROFESSIONAL_FORM_SUBMIT(
      formState,
      setProcessing,
      setErrors,
      false,
      dispatch
    )
  }

  const handleSaveAndContinue = e => {
    e.preventDefault()
    setProcessing(true)
    CANDIDATE_PROFESSIONAL_FORM_SUBMIT(
      formState,
      setProcessing,
      setErrors,
      true,
      dispatch
    )
  }

  const onFocus = () => {
    setErrors([])
  }

  const getCurrentCountrySalary = () => {
    if (configData?.salary) return configData.salary.filter(x => x.country === country)
  }

  const getSalaryCurrency = () => {
    const salary = getCurrentCountrySalary()
    return salary ? salary[0].currency_code : ""
  }

  useEffect(() => { }, [images, configData, errors])

  return (
    <form className="professional-form">
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <Row>
            <Col lg="6">
              <InputTextBox
                name="job-title"
                class={errors.position && "error"}
                value={formState.position || ""}
                placeholder="Accountant"
                label={
                  <>
                    Job Title<span>*</span>
                  </>
                }
                onFocus={onFocus}
                onChange={handleJobTitleChange}
              />
            </Col>
            <Col lg="6">
              <TagInput
                name="industry"
                styles={` outline-faded`}
                error={errors?.industry ? `error` : ""}
                options={configData?.industry}
                value={selectValueFromId(
                  configData?.industry,
                  formState?.industry
                )}
                onFocus={onFocus}
                label={
                  <>
                    Industry<span>*</span>
                  </>
                }
                placeholder={"Type and Select..."}
                useOnChange={handleIndustryChange}
                closeMenuOnSelect
                isClearable
              />
              {/* <InputBox
                type="select"
                optionHeader="Select"
                name="industry"
                styles={
                  errors.industry
                    ? "rounded-border outline-faded error"
                    : "rounded-border outline-faded"
                }
                value={formState.industry}
                options={configData.industry}
                key_value="name"
                onChange={handleIndustryChange}
                placeholder="Select industry"
                label={
                  <>
                    Industry<span>*</span>
                  </>
                }
              /> */}
            </Col>
          </Row>
          <Row>
            <Col lg="6" md="12">
              <InputBox
                onFocus={onFocus}
                type="select"
                name="available"
                key_value="status"
                styles={
                  errors.status
                    ? `rounded-border outline-faded error`
                    : `rounded-border outline-faded`
                }
                optionHeader="Select"
                options={configData.status}
                value={formState.status}
                onChange={handleStatusChange}
                label={
                  <>
                    Status<span>*</span>
                  </>
                }
              />
            </Col>
            <Col lg="4 pr-0" md="10" xs="8">
              <InputTextBox
                name="salary"
                placeholder="Expected Salary"
                class={errors.salary && "error"}
                styles={
                  errors.salary
                    ? `rounded-border outline-faded error`
                    : `rounded-border outline-faded`
                }
                onFocus={onFocus}
                value={formatSalaryWithComma(formState.salary)}
                onChange={handleExpectedSalaryChange}
                label={
                  <>
                    Expected salary(/month)<span>*</span>
                  </>
                }
              />
            </Col>
            <Col lg="2" md="2" xs="4">
              <div className="form-group">
                <label htmlFor="salary">&nbsp;</label>
                <input
                  id="salary"
                  className="form-control "
                  type="text"
                  disabled
                  styles="rounded-border outline-faded"
                  onChange={() => null}
                  value={getSalaryCurrency()}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <InputBox
                type="select"
                name="work-type"
                styles={
                  errors.job_type
                    ? `rounded-border outline-faded error`
                    : `rounded-border outline-faded`
                }
                onFocus={onFocus}
                optionHeader="Select"
                key_value="name"
                options={configData.job_type}
                value={formState.job_type_id}
                onChange={handleWorkTypeChange}
                label={
                  <>
                    Work Type(Preferred)<span>*</span>
                  </>
                }
              />
            </Col>
            <Col lg="6">
              <InputBox
                type="select"
                name="work-shift"
                styles={
                  errors.job_shift
                    ? `rounded-border outline-faded error`
                    : `rounded-border outline-faded`
                }
                onFocus={onFocus}
                optionHeader="Select"
                key_value="name"
                options={configData.shift}
                value={formState.job_shift_id}
                onChange={handleWorkShiftChange}
                label={
                  <>
                    Work Shift(Preferred)<span>*</span>
                  </>
                }
              />
            </Col>
            {/* <Col lg="4">
              <InputTextBox
                name="work-shift1"
                styles="rounded-border outline-faded"
                label="&nbsp;"
              />
            </Col> */}
          </Row>
          {formState.industry_skills && formState.industry_skills.length > 0 && (
            <Row>
              <Col lg="12">
                <TagInput
                  name="skills"
                  styles={
                    errors.skills ? `outline-faded error` : `outline-faded`
                  }
                  options={formatSkillsForSelect(formState.industry_skills)}
                  value={formatSkillsForSelect(formState.skills)}
                  onFocus={onFocus}
                  label="Skills"
                  placeholder={"Type and Select..."}
                  formState={formState}
                  setFormState={setFormState}
                  closeMenuOnSelect
                  isMulti
                  isClearable
                />
              </Col>
            </Row>
          )}
        </>
      )}
      <>
        <Row className="align-items-center">
          <Col xs="6" md="8">
            <div className="d-flex align-items-center">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="mb-0">Portfolio</label>

              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                aria-hidden="true"
                className="btn-custom plus blue text-center d-block ml-1"
                onClick={() => setAddPortfolio(true)}
              >
                +
              </a>
            </div>
          </Col>
          <Col xs="6" md="4" className="text-right"></Col>
        </Row>
        <div className="separator-border"></div>
        <Row>
          {isLoading ? (
            <Spinner />
          ) : images.length > 0 ? (
            images.map((image, index) => {
              return (
                <Col
                  key={index}
                  sm="6"
                  lg="4"
                  className="mb-4 portfolio-images__wrapper"
                >
                  <div className="buttons hide-buttons d-flex align-items-center">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      aria-hidden="true"
                      className="cross"
                      onClick={() => setAddPortfolio(true, image.id)}
                    >
                      <img src={Edit} alt="wdn-edit" />
                    </a>
                    <div className="cross">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        aria-hidden="true"
                        onClick={() =>
                          setShowDeleteForm(true, image.id, "PORTFOLIO")
                        }
                      >
                        <img src={Wrong} alt="wdn-cross" />
                      </a>
                    </div>
                  </div>

                  <img
                    className="portfolio-image"
                    src={image.image}
                    alt={image.title ? image.title : "Portfolio Image"}
                  />
                </Col>
              )
            })
          ) : (
            <Col className="mb-4 portfolio-images__wrapper">
              <p className="p-0">Nothing to show</p>
            </Col>
          )}
        </Row>
      </>
      <>
        <Row className="align-items-center">
          <Col xs="6" md="8">
            <div className="d-flex align-items-center">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="mb-0">Past Experiences</label>

              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                aria-hidden="true"
                className="btn-custom plus blue text-center ml-1"
                onClick={() => setAddPastExp(true)}
              >
                +
              </a>
            </div>
          </Col>
          <Col xs="6" md="4" className="text-right"></Col>
        </Row>
        <div className="separator-border"></div>
        {isLoading ? (
          <Spinner />
        ) : experiences && experiences.length > 0 ? (
          <>
            <TimeLine
              setShowDeleteForm={setShowDeleteForm}
              onClick={handleTimelineEditButtonClick}
              experiences={experiences}
            />
            <div></div>
          </>
        ) : (
          <div className="pb-4">
            <p>Nothing to show.</p>
          </div>
        )}
      </>
      <Row>
        <Col>
          {errors &&
            Object.keys(errors)
              .slice(0, 1)
              .map((key, value) => {
                if (
                  formState.position === "" ||
                  formState.industry === "" ||
                  formState.status === ""
                ) {
                  return (
                    <div
                      key={value}
                      className="alert-block mb-4 d-flex align-items-center"
                    >
                      <img src={Warning} className="mr-3" alt="wdn-warning" />
                      {errors[key]}
                    </div>
                  )
                } else if (formState.salary === "") {
                  return (
                    <div
                      key={value}
                      className="alert-block mb-4 d-flex align-items-center"
                    >
                      <img src={Warning} className="mr-3" alt="wdn-warning" />
                      Salary is required.
                    </div>
                  )
                } else if (
                  formState.job_type === "" ||
                  formState.job_shift === ""
                ) {
                  return (
                    <div
                      key={value}
                      className="alert-block mb-4 d-flex align-items-center"
                    >
                      <img src={Warning} className="mr-3" alt="wdn-warning" />
                      Work Type is required.
                    </div>
                  )
                } else {
                  return (
                    <div
                      key={value}
                      className="alert-block mb-4 d-flex align-items-center"
                    >
                      <img src={Warning} className="mr-3" alt="wdn-warning" />
                      {errors[key]}
                    </div>
                  )
                }
              })}
        </Col>
      </Row>
      <Row>
        <Col lg={{ span: "3", offset: "2" }}>
          <Link
            to="/candidate/personal"
            className="btn w-100 btn-custom rounded  p-3 blue-outline my-2"
          >
            Back
          </Link>
        </Col>
        <Col lg={{ span: "3" }}>
          <button
            onClick={handleSave}
            className="btn w-100 btn-custom p-3 rounded primary my-2"
            disabled={isProcessing}
          >
            {isProcessing ? "Processing" : "Save"}
          </button>
        </Col>
        <Col lg={{ span: "4" }}>
          <button
            onClick={handleSaveAndContinue}
            className="btn w-100 btn-custom p-3 rounded primary my-2"
            disabled={isProcessing}
          >
            {isProcessing ? "Processing" : "Save and continue"}
          </button>
        </Col>
      </Row>
    </form>
  )
}

export default ProfessionalForm
